import { apiClientPublic } from "services/api-client"

export const getProductsCheckout = async () => {
    return await apiClientPublic.get(`/checkout/products`)
}

export const getPricesByProductCheckout = async (productId) => {
    return await apiClientPublic.get(`/checkout/prices/by-product/${productId}`)
}

export const createCheckoutSession = async (priceId, slug) => {
    return await apiClientPublic.post(`/checkout/create-session`, {
        priceId,
        slug
    })
}